import React from 'react';
import { Link } from 'react-scroll';


//image: '/images/Max_placeholder.jpg'
//<img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mx-auto mb-4" />
const Header = () => {
  return (
    <header className="bg-black text-white p-4 fixed w-full z-10">
      <div className="container mx-auto flex justify-between items-center">
        {/* <div className="text-xl font-bold">Max Hauling</div> */}
        <div className="logo_div">
          {/* <img src="/images/M_Hauling_logo_2.svg" alt="Max Hauling truck logo"/> */}
          {/* C:\Users\Monolith\Desktop\Max\Max_hauling_website\max-hauling\public\images\M_hauling_logo_black_bg.svg */}
          <img src="/images/M_hauling_logo_black_bg.svg" alt="Max Hauling truck logo"/>
        </div>
        <div className="flex flex-col items-center ">
          <div>
            FREE ESTIMATES
          </div>
          <div>
            WEEKEND JUNK REMOVAL AND HAULING
          </div>
        </div>
        <nav>
          <ul className="flex space-x-4">
            <li>
              <Link
                to="hero"
                smooth={true}
                duration={500}
                // offset={-70}
                className="cursor-pointer text-blue-500 hover:text-white"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="services"
                smooth={true}
                duration={500}
                // offset={-70}
                className="cursor-pointer text-blue-500 hover:text-white"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="about"
                smooth={true}
                duration={500}
                // offset={-70}
                className="cursor-pointer text-blue-500 hover:text-white"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                // offset={-70}
                className="cursor-pointer text-blue-500 hover:text-white"
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
